export enum ModalName {
	MissionDetails = 'mission-details',
	ManageOrderModal = 'manage-order-modal',
	MissionSelection = 'mission-selection',
	CancelMissionLegacy = 'cancel-mission-legacy',
	SendOrderToEvolia = 'send-order-to-evolia',
	PaymentRequestCreationModal = 'payment-request-creation-modal',
	PaymentRequestActionModal = 'payment-request-action-modal',
	ProfileUnavailabilityModal = 'profile-unavailability-modal',
	TooMuchWorkerConfirm = 'too-much-worker-confirm',
	SwitchWorkerStatus = 'switch-worker-status',
	ShowActiveProposalEmail = 'show-active-proposal-email',
	DocumentPreviewModal = 'document-preview-modal',
	NirAlreadyExistsModal = 'nir-already-exists-modal',
	SearchCompanyNeedsModal = 'search-company-needs-modal',
	ManageCompanyNeedModal = 'manage-company-need-modal',
	MoveWorkerCompanyNeedModal = 'move-worker-company-need-modal',
	CompanyNeedMissionDetailsModal = 'company-need-mission-details-modal',
	CompanyNeedMissionAddWorkerToMissionModal = 'company-need-mission-add-worker-to-mission-modal',
	RejectProfileWorkerModal = 'reject-profile-worker-modal',
	LastContactModal = 'last-contact-modal',
	ProfileScheduleInterviewModal = 'profile-schedule-interview-modal',
	JustificationModal = 'justification-modal',
	ProfilPreviewModal = 'profil-preview-modal',
	WorkerAgencyRejectModal = 'worker-agency-reject-modal',
	CancelMission = 'cancel-mission',
	ValidateMission = 'validate-mission',
	MissionExtensionModal = 'mission-extension-modal',
	SendActiveProposalModal = 'send-active-proposal-modal',
	InterviewReportModal = 'interview-report-modal',
	InterviewEditModal = 'interview-edit-modal',
	WorkerAskedChangesModal = 'worker-asked-changes-modal',
	ProfileNoteModal = 'profile-note-modal',
	CreateCandidateModal = 'create-candidate-modal',
	DuplicatedWorkerModal = 'duplicated-worker-modal',
	RepublishUnavailableModal = 'republish-unavailable-modal',
	WorkersBulkActionsModal = 'workers-bulk-actions-modal',
	ClientSalesforceImportModal = 'client-salesforce-import-modal',
}
